<p-table
  [value]="cancelData()">
  <ng-template pTemplate="header">
    <tr>
      <th>User ID</th>
      <th>Cancel Date</th>
      <th>Reason</th>
      <th>Details</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-data [cTypedTableRow]="cancelData()">
    <tr>
      <td><a class="underline text-blue-500" href="/users/{{data.userId}}" target="_blank">{{data.userId}}</a></td>
      <td>{{ data.cancelDate | date:'M/d/yy, h:mm a' }}</td>
      <td>{{ data.reason }}</td>
      <td>{{ data.details }}</td>
    </tr>
  </ng-template>
</p-table>
